import {OpenamApi} from "./api/am/openamApi";
import {PortalApi} from "./api/portal/portalApi";

const apis = {
    openam: new OpenamApi(),
    portal: new PortalApi(),
};
export default apis;
